import FroalaEditor from "react-froala-wysiwyg";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import AceEditor from "react-ace";
import jsBeautify from "js-beautify";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-nord_dark";
import "./custom-theme.css";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/keybinding-vscode";
import "ace-builds/src-noconflict/ext-searchbox";

export default class LiveCodeEditor extends Component {
  
  constructor(props) {
    super(props);

    this.aceEditor = null; // reference

    const { content, form_control_name } = props.data;
    const csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    
    this.state = {
      froala_content: content,
      editor_content: content,
      csrf_token: csrf,
      show_advanced_editor: false,
      form_control_name: form_control_name,
      toolbarButtons: {
        moreText: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "strikeThrough",
            "subscript",
            "superscript",
            "fontFamily",
            "fontSize",
            "textColor",
            "backgroundColor",
            "inlineClass",
            "inlineStyle",
            "clearFormatting",
          ],
        },
        moreParagraph: {
          buttons: [
            "alignLeft",
            "alignCenter",
            "formatOLSimple",
            "alignRight",
            "alignJustify",
            "formatOL",
            "formatUL",
            "paragraphFormat",
            "paragraphStyle",
            "lineHeight",
            "outdent",
            "indent",
            "quote",
          ],
        },
        moreRich: {
          buttons: [
            "insertLink",
            "insertImage",
            "insertVideo",
            "insertTable",
            "emoticons",
            "fontAwesome",
            "specialCharacters",
            "embedly",
            "insertFile",
            "insertHR",
          ],
        },
        moreMisc: {
          buttons: [
            "undo",
            "redo",
            "fullscreen",
            "print",
            "getPDF",
            "spellChecker",
            "selectAll",
            "help",
          ],
          align: "right",
          buttonsVisible: 2,
        },
      },
    };

    this.onAceEditorChange = this.onAceEditorChange.bind(this);
    this.onFroalaEditorChange = this.onFroalaEditorChange.bind(this);
    this.toggleEditor = this.toggleEditor.bind(this);
    this.formatEditorHTML = this.formatEditorHTML.bind(this);
    this.findInEditor = this.findInEditor.bind(this);
  }

  formatHTML(content){
    return jsBeautify.html_beautify(content, { wrap_attributes: "aligned-multiple", wrap_line_length: 140, extra_liners: ["a", "img"], preserve_newlines: true })
  }

  formatEditorHTML(){ 
    const newContent = this.formatHTML(this.state.editor_content);  
    this.setState({
      editor_content: newContent
    })
  }

  onAceEditorChange(value) {
    this.setState({
      editor_content: value
    });
  }

  onFroalaEditorChange(value){
    this.setState({
      froala_content: value,
      editor_content: value,
    })
  }

  toggleEditor() {
    const show_advanced_editor = !this.state.show_advanced_editor;
    if(show_advanced_editor){
      this.formatEditorHTML();
    }else {
      //update froala editor content
      this.setState({
        froala_content: this.state.editor_content
      });
    }

    this.setState({
      show_advanced_editor
    });
  }

  findInEditor() {
    this.aceEditor.editor.execCommand('find', 'h1');
  }

  render() {
    const { env, editor_id } = this.props.data;

    return (
      <div className="code-editor-container">
        <div className="mb-2">
          <button
            type="button"
            className="btn btn-transparent p-0 text-primary"
            onClick={this.toggleEditor}
          >
            { this.state.show_advanced_editor ? "Preview" : "Code View"}
          </button>
        </div>

        {this.state.show_advanced_editor && 
          <div>
            <div
              className="py-2"
              style={{ backgroundColor: "#2e3440", borderRadius: "5px" }}
            >
              <AceEditor
                ref={(el) => (this.aceEditor = el)}
                mode="html"
                theme="nord_dark"
                onChange={(event) => {
                  this.onAceEditorChange(event);
                }}
                name={editor_id}
                value={this.state.editor_content}
                editorProps={{ $blockScrolling: true }}
                width="100%"
                height="90vh"
                fontSize={16}
                keyboardHandler="vscode"
                enableBasicAutocompletion
                showPrintMargin={false}    
                onPaste={() => setTimeout(() => this.formatEditorHTML(), 100)}
                wrapEnabled={true}         
              />
            </div>
          </div>
        } 
                
        <div
          style={{ display: this.state.show_advanced_editor ? 'none' : 'block' }}
        >
          <FroalaEditor
            config={{
              charCounterCount: true,
              codeMirror: CodeMirror,
              enter: FroalaEditor.ENTER_BR,
              heightMin: '200px',
              key: env.FROALA_KEY,
              htmlAllowedEmptyTags: [
                ".fa",
                ".far",
                ".zmdi",
                "iframe",
                "script",
                "video",
                "textarea",
                "style",
                "div",
              ],
              htmlExecuteScripts: false,
              htmlRemoveTags: [],
              toolbarButtons: this.state.toolbarButtons,
              toolbarButtonsSM: this.state.toolbarButtons,
              toolbarButtonsMD: this.state.toolbarButtons,
              // Set the image upload parameter.
              imageUploadParam: 'media', 
              // Set the image upload URL.
              imageUploadURL: this.props.data.image_upload_url,
              // Set request type.
              imageUploadParams: { _token: this.state.csrf_token },
              // Set request type.
              imageUploadMethod: 'post',
              // Set page size.
              imageManagerPageSize: 4,
              // Set the load images request URL.
              imageManagerLoadURL: this.props.data.image_manager_load_url,
              // Set the load images request type.
              imageManagerLoadMethod: "get",
              // Additional load params.
              imageManagerLoadParams: {_token: this.state.csrf_token },
              // Request Headers.              
              requestHeaders: {Accept: "application/json"}
            }}
            model={this.state.froala_content}
            onModelChange={(event) => {
              if (!this.state.show_advanced_editor) {
                this.onFroalaEditorChange(event);
              }
            }}
          />
        </div>

        <textarea
          className="d-none"
          name={this.state.form_control_name}
          value={this.state.editor_content}
          readOnly
        ></textarea>
      </div>
    );
  }
}

if (document.querySelector(".live-code-editor")) {
  const elements = document.querySelectorAll(".live-code-editor");

  Array.from(elements).forEach(element => {
    const data = Object.assign({}, element.dataset);
  
    ReactDOM.render(<LiveCodeEditor data={JSON.parse(data.data)} />, element);
  })
}



// WEBPACK FOOTER //
// ./resources/js/components/LiveCodeEditor/index.js